import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { AuthAPI } from "../services/auth.api";
import { AuthStore } from "../auth/authStore";
import logoRTC from "../assets/img/gky-logo.png"; // ganti sesuai nama file logo lo
import "./login.scss";

export default function Login() {
  const navigate = useNavigate();
  const location = useLocation();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  /* ===============================
     AUTO REDIRECT IF LOGGED IN
  =============================== */
  useEffect(() => {
    if (AuthStore.isLoggedIn()) {
      navigate("/admin/dashboard", { replace: true });
    }
  }, [navigate]);

  /* ===============================
     SUBMIT
  =============================== */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    setError(null);
    setLoading(true);

    const from =
      location.state?.from?.pathname ||
      "/admin/dashboard";

    try {
      await AuthAPI.login(email, password);
      navigate(from, { replace: true });
    } catch (err) {
      setError(
        err.response?.data?.message ||
          err.message ||
          "Login failed"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login">
      <div className="login-card">

        {/* BRAND */}
        <div className="login-brand">
          <img
            src={logoRTC}
            alt="RTCGKY"
            className="login-logo"
          />
          <h1>RTCGKY Admin</h1>
          <p className="tagline">
            Masuk untuk mengelola event, tiket, dan sistem booking.
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <label>
            Email
            <input
              type="email"
              placeholder="admin@rtcgky.com"
              value={email}
              required
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>

          <label>
            Password
            <div className="password-field">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Masukkan password"
                value={password}
                required
                onChange={(e) =>
                  setPassword(e.target.value)
                }
              />

              <button
                type="button"
                className="toggle-password"
                onClick={() =>
                  setShowPassword((v) => !v)
                }
                aria-label="Toggle password"
              >
                {showPassword ? (
                  <EyeOff size={18} />
                ) : (
                  <Eye size={18} />
                )}
              </button>
            </div>
          </label>

          <button
            className="btn-login"
            type="submit"
            disabled={loading}
          >
            {loading
              ? "Logging in..."
              : "Masuk ke Dashboard"}
          </button>

          {error && (
            <div className="error">
              {error}
            </div>
          )}
        </form>

        <div className="login-footer">
          <p>
            Sistem internal RTCGKY — Restricted Access
          </p>
        </div>
      </div>
    </div>
  );
}